/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Component to present an empty plugin
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-grid-plugin-view[_ngcontent-%COMP%]{height:43px;border:1px solid #ccc;background-color:#fafafa}.sym-grid-plugin-view.sym-grid-plugin-view-empty[_ngcontent-%COMP%]{margin-right:15px}"];
export { styles as styles };
